import { render, staticRenderFns } from "./UsersActionAdmin.vue?vue&type=template&id=5ff58764&scoped=true&"
import script from "./UsersActionAdmin.vue?vue&type=script&lang=ts&"
export * from "./UsersActionAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./UsersActionAdmin.vue?vue&type=style&index=0&id=5ff58764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff58764",
  null
  
)

export default component.exports